<template>
  <svg width="13"
       height="17"
       viewBox="0 0 13 17"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.08317 0.583336H1.74984C1.32991 0.583336 0.927184 0.750151 0.630251 1.04708C0.333319 1.34402 0.166504 1.74674 0.166504 2.16667V14.8333C0.166504 15.2533 0.333319 15.656 0.630251 15.9529C0.927184 16.2499 1.32991 16.4167 1.74984 16.4167H11.2498C11.6698 16.4167 12.0725 16.2499 12.3694 15.9529C12.6664 15.656 12.8332 15.2533 12.8332 14.8333V5.33334L8.08317 0.583336ZM4.24755 12.8178C3.9103 13.098 3.39809 13.2302 2.77188 13.2302C2.39584 13.2302 2.13063 13.2065 1.95013 13.1827V10.039C2.2739 9.99238 2.60074 9.97041 2.92784 9.97329C3.53584 9.97329 3.93009 10.0825 4.23805 10.3153C4.57055 10.5623 4.77955 10.9565 4.77955 11.5202C4.77955 12.1338 4.55629 12.5565 4.24755 12.8178ZM6.61463 13.25C5.66463 13.25 5.10967 12.5328 5.10967 11.6208C5.10967 10.662 5.72163 9.94559 6.66688 9.94559C7.64934 9.94559 8.18609 10.681 8.18609 11.5645C8.1853 12.6135 7.5488 13.25 6.61463 13.25ZM10.2998 12.6468C10.5175 12.6468 10.7598 12.5985 10.9031 12.5423L11.0123 13.1067C10.8793 13.1732 10.5801 13.2445 10.1914 13.2445C9.08542 13.2445 8.51542 12.5565 8.51542 11.6445C8.51542 10.5528 9.29363 9.94559 10.2626 9.94559C10.6379 9.94559 10.9221 10.0216 11.0503 10.0881L10.9031 10.6628C10.7103 10.5832 10.5036 10.5428 10.2951 10.5441C9.72034 10.5441 9.27384 10.8908 9.27384 11.6033C9.27384 12.2438 9.65384 12.6468 10.2998 12.6468ZM8.08317 6.125H7.2915V2.16667L11.2498 6.125H8.08317Z"
      :fill="color" />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#FFF"
    }
  }
}
</script>
